import { AuthenticatedUserProp } from "@/types";
import { usePage } from "@inertiajs/react";

export default function usePermissions() {
  const { permissions, authenticated } = usePage().props;

  function can(permissionName: keyof AuthenticatedUserProp["permissions"]) {
    if (authenticated) {
      return permissions[permissionName] ?? false;
    }

    return false;
  }

  return { permissions, can };
}
